module.exports = __webpack_public_path__ + "img/1.2fcb1a7c.png";